import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import Home from "./pages/Home";
import CreateFlow from "./pages/CreateFlow";
import NotFound from "./pages/NotFound";
import PedidosAdmin from "./pages/admin/PedidosAdmin";

const App = () => {
  const location = useLocation();

  return (
    <AnimatePresence exitBeforeEnter>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/crear" element={<CreateFlow />} />
        <Route path="/admin-pedidos" element={<PedidosAdmin />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
};

export default App;
